// 新版多币种画布页面翻译 - 简体中文
export default {
  // 对话框标题
  dialogs: {
    note: "备注",
    batchNote: "批量备注",
    separateNote: "分开备注",
    unifiedNote: "统一备注",
    addLabel: "添加标签",
    editLabel: "修改标签",
    deleteLabel: "删除标签",
    addMonitor: "添加监控",
    saveInfo: "保存信息",
    modifyInfo: "修改信息",
  },

  // 表单标签
  forms: {
    label: "标签",
    notePlaceholder: "请输入备注内容",
    selectPlaceholder: "请选择",
    inputPlaceholder: "请输入内容",
  },

  // 成功提示信息
  success: {
    monitorAdded: "地址监控添加成功",
    caseDataAdded: "地址加入数据看板添加成功",
    caseDataAnalyzing: "案件数据分析中，请耐心等待",
    verifyResultReady: "已有验证结果",
  },

  // 按钮文字
  buttons: {
    cancel: "取消",
    confirm: "确定",
    closeDialog: "关闭弹窗",
    viewMonitor: "查看监控",
    viewCaseData: "查看案件数据",
    viewVerifyResult: "查看验证结果",
    addNew: "新增",
  },

  // 加载状态
  loading: {
    text: "拼命加载中",
  },

  // 左侧菜单
  leftMenu: {
    details: "详情",
    filter: "筛选",
    survey: "调证",
    history: "历史",
    canvasFilter: "画布筛选",
  },

  // 提示信息
  tooltip: {
    unsavedCanvas:
      "请先保存并关联案件(未命名画布无法自动保存)；完成后可解锁更多深度分析能力。",
  },

  // 通知消息
  notifications: {
    tooManyNodes: {
      title: "提示",
      message: "画布节点过多，可能会影响画布效率，建议新建画布",
    },
    aggregateEdgeWarning: {
      title: "警告",
      message: "操作聚合边不支持展开",
    },
    aggregateNodeWarning: {
      title: "提示",
      message: "聚合点不支持该操作！",
    },
  },
};
